<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  methods: {
    getweb(){
     const xhr = new XMLHttpRequest();
     xhr.open('post','http://customerapp.eci-metro.cn/ecim/admin/webapp/view');
     xhr.send();
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    if (this._isMobile()) {
      this.$router.push("/home");
    } else {
      this.$router.push("/about");
    }
  },
  created(){
    this.getweb();
  }
};
</script>

<style lang="less">
#app {
  height: 100%;
  width: 100%;
}
</style>
